module.exports = __webpack_public_path__ + "img/cck.2da4bb97.svg";